import { SunfishApi } from '../../shared/sdk/services/custom';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { Storage } from '@ionic/storage';
import { StoragePathProvider } from '../storage-path/storage-path';
import { AnalyticsProvider } from '../analytics/analytics';
import { SFGOAuthService } from '../sfgoauth.service/sfgoauth.service';
import { AppPreferences } from '../../shared/local/app-preferences.local';
import { FileUploaderProvider, OptionsUploadWithHttp } from '../file-uploader/file-uploader';
import { GlobalServiceProvider } from '../global-service/global-service';

@Injectable()
export class UploadAttachmentProvider {
  constructor(
    public http: HttpClient,
    public sunfish: SunfishApi,
    public platform: Platform,
    public transfer: FileTransfer,
    public storage: Storage,
    public storagePathProvider: StoragePathProvider,
    public analyticsProvider: AnalyticsProvider,
    public sfgoAuthService: SFGOAuthService,
    private appPreferences: AppPreferences,
    private fileUploader: FileUploaderProvider,
    private globalService: GlobalServiceProvider
  ) {
    // console.log('Hello UploadAttachmentProvider Provider');
  }

  async getUrlFile(userid, picture): Promise<any> {
    let urlFile = '';
    try {
      const auth = await this.appPreferences.getAuth();
      const storagePath = await this.storagePathProvider.getStorageAttachmentFile(auth, userid);
      urlFile = this.storagePathProvider.getUrlDownload(storagePath.urlDownload, picture);
      return Promise.resolve(urlFile);
    }
    catch (error) {
      return Promise.resolve(urlFile);
    }
  }

  runUploadSFGO(data, objUpload?: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const auth = await this.appPreferences.getAuth();
        const storage = await this.storagePathProvider.getStorageAttachmentFile(auth, auth.userId)
        const fileToUpload = this.platform.is('cordova') ? data.url : <Array<File>>data.eventsWebview.target.files;
        const upload = await this.uploadFile(storage.urlUpload, fileToUpload, data.options);

        const objRes = {
          RESULT: upload.fileName ? true : false,
          SERVERFILE: upload.fileName,
          ERRMSG: upload.fileName ? '' : 'upload file failed'
        };

        resolve(objRes);
      } catch (error) {
        reject(error);
      }
    })
  }

  getTokenAttachment(data, objUpload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.storage.get('SFGoAuth').then(auth => {
        const datas = [JSON.parse(auth).companyCode, data.uploadCode, JSON.parse(auth).userName, objUpload];
        const photopath = JSON.parse(auth).empphotopath;
        this.sunfish.getTokenAttachment(datas, photopath).subscribe(
          result => {
            const data = {
              url: result.pathUpload,
              configs: JSON.stringify(datas),
            };
            resolve(data);
          },
          error => {
            reject(error);
          }
        )
      })
    })
  }

  runUploadMobile(data, url): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const fileTransfer: FileTransferObject = this.transfer.create();
      const fileUploadOptions: FileUploadOptions = data.options;
      fileTransfer.upload(data.url, url, fileUploadOptions)
        .then((data) => {
          resolve(JSON.parse(data.response));
        }, (err) => {
          console.log(err);
          reject(err);
        });
    })
  }

  runUploadSF6(data, objUpload): Promise<any> {
    return new Promise((resolve, reject) => {
      const me = this;
      this.storage.get('SFGoAuth').then(auth => {
        let datas = [JSON.parse(auth).companyCode, data.uploadCode, JSON.parse(auth).userName, objUpload];
        console.log("datas", datas);
        let photopath = JSON.parse(auth).empphotopath;
        console.log("photopath", photopath);

        this.sunfish.getTokenAttachment(datas, photopath).subscribe(
          result => {
            console.log("result", result);

            if (me.platform.is('cordova')) {
              const fileTransfer: FileTransferObject = me.transfer.create();
              let fileUploadOptions: FileUploadOptions = data.options;
              fileTransfer.upload(data.url, result.pathUpload, fileUploadOptions)
                .then((data) => {
                  // let namePicture = JSON.parse(data['response']).SERVERFILE;
                  console.log("result", JSON.stringify(data['response']));
                  let objRes = {
                    RESULT: JSON.parse(data['response']).RESULT,
                    SERVERFILE: JSON.parse(data['response']).SERVERFILE,
                    ERRMSG: JSON.parse(data['response']).ERRMSG
                  };
                  resolve(objRes);
                }, (err) => {
                  console.log(err);
                  reject(err);
                });
            } else {
              let filesToUpload = <Array<File>>data.eventsWebview.target.files;
              me.makeFileRequest(result.pathUpload, [], filesToUpload, data.options).then((result) => {

                let namePicture = JSON.parse(JSON.stringify(result)).SERVERFILE;
                console.log("namePicture", namePicture, "result", result);
                let objRes = {
                  RESULT: JSON.parse(JSON.stringify(result)).RESULT,
                  SERVERFILE: JSON.parse(JSON.stringify(result)).SERVERFILE,
                  ERRMSG: JSON.parse(JSON.stringify(result)).ERRMSG
                };
                resolve(objRes);
              }, (error) => {
                console.log(error);
                reject(error);
              });
            }

          },
          error => {
            reject(error);
          }
        )
      })
    })
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>, options) {
    return new Promise((resolve, reject) => {
      const formData: any = new FormData();
      const xhr = new XMLHttpRequest();
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i], options);
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      };
      xhr.open('POST', url, true);
      xhr.send(formData);
    });
  }

  async uploadFile(url: string, file: any, options) {
    return new Promise<{ fileName: string }>(async (resolve, reject) => {
      try {
        let result = { fileName: null }
        console.log('file', file, options)
        if (this.platform.is('cordova')) {
          result.fileName = await this.uploadFileNative(url, file, options);
        }
        else {
          result.fileName = await this.uploadFileWeb(url, file, options);
        }

        resolve(result);
      } catch (error) {
        reject(error);
      }
    })
  }

  uploadFileNative(url: string, file: any, options) {
    return new Promise(async (resolve, reject) => {
      const ext = this.globalService.checkTypeAttachment(file);
      const option: OptionsUploadWithHttp = {
        nativeURI: file,
        type: ext,
        eventsWebview: null,
        options: options
      }

      try {
        const result = await this.fileUploader.uploadWithHttp(option, url);
        resolve(result);
      } catch (error) {
        reject(error);
      }
    })
  }

  uploadFileWeb(url: string, files: Array<File>, options) {
    return new Promise(async (resolve, reject) => {
      const auth = await this.appPreferences.getAuth();
      const timeout = `${(5 * 60) * 1000}`;
      const headers: HttpHeaders = new HttpHeaders({ timeout, isUpload: 'true' })
        .set('Authorization', auth.id);
      const formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i], options);
      }

      this.http.post(url, formData, { headers, reportProgress: true })
        .subscribe((response: any) => {
          console.log('res', response);
          const fileName = response.hasOwnProperty('data') && response.data ? response.data.fileName : response.result.files.file[0].name;
          resolve(fileName);
        }, error => {
          reject(error)
        });
    })
  }


}



// WEBPACK FOOTER //
// ./src/providers/upload-attachment/upload-attachment.ts